<template>
  <div
    ref="spContainer"
    class="sp-container"
    @mouseenter="showSituationCard()"
    @mouseleave="showSituationCard()"
  >
    <div @click="gotoSituation()">
      <div
        class="sp-dot"
        :class="{ 'sp-currentSituation': coversCurrentSituation() }"
      >
        {{ calculatedID }}
      </div>
      <div class="station-name" v-if="this.chosenLanguage=='de'">{{ station }}</div>
      <div class="station-name" v-if="this.chosenLanguage=='en'">{{ station_en }}</div>
      <div class="sp-ppl" v-if="usersLength && enableCommunication">
        {{ usersLength }}
      </div>
    </div>
    <!--  
         <transition name="fade">
            <SituationCard ref="spCard" class="sp-card" v-show="showCard" :situation="situation" :style="cardPosition"/>
        </transition> -
       -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import SituationCard from "@/components/flux360/EmbeddedDialogues/MapDialogue/SituationCard";

export default {
  components: { SituationCard },
  props: ["situations", "stationID", "station", "station_en"],
  inject: ["toggleMap"],
  data: () => ({
    showCard: false,
    situation: "",
    station: "",
  }),
  methods: {
    ...mapMutations(["handleGotoSituationTransition"]),
    showSituationCard() {
      this.showCard = !this.showCard;
    },
    gotoSituation() {
      this.toggleMap();
      this.handleGotoSituationTransition({
        situationID: this.situations[0].id,
      });
    },
    coversCurrentSituation() {
      //console.log("coversCurrentSituation: ")
      let x = false;
      //console.log(this.situations)
      this.situations.forEach((element) => {
        if (element.id == this.currentSituationID) {
          //console.log("FOUND IT")
          x = true;
          return true;
        }
      });
      //console.log("returning false")
      return x;
    },
  },
  computed: {
    ...mapGetters(["currentSituationID", "users", "enableCommunication",  "chosenLanguage"]),

    usersLength() {
      return this.users.filter((x) =>
        this.situations.includes(x.getCurrentSituationID())
      ).length;
    },
    cardPosition() {
      // console.log(this.$refs.spContainer);
      if (!this.$refs.spContainer) return;
    },
    calculatedID() {
      return this.stationID <= 1 ? "" : this.stationID - 1;
    },
  },
  mounted: function () {
    console.log();
    /*
        let style = getComputedStyle(this.$refs.spContainer);
        let left = parseInt(style.left);
        let top = parseInt(style.top);
        
        if(top>60)
            this.$refs.spCard.$el.style.top = "-270px";
        if(left>60)
            this.$refs.spCard.$el.style.left = "-480px";
            */
  },
};
</script>

<style>
.station-name {
  color: white;
  position: relative;
  left: 50px;
  top: -30px;
}
.sp-container {
  transform: translate(-50%, -50%);
}
.sp-container:hover .sp-dot {
  transform: scale(1.3);
  z-index: 5;
}
.sp-container:hover .sp-ppl {
  z-index: 6;
  cursor: pointer;
}
.sp-dot {
  z-index: 1;
  position: relative;
  cursor: pointer;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: solid 5px var(--primaryColor);
  /* background: var(--secondaryColor); */
  background: rgba(255, 255, 255, 0.4);
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.4))
    drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.4));
  transition: background-color 0.2s, transform 0.2s, filter 0.2s;

  color: var(--primaryColor);
  font-size: 1.2rem;
  font-weight: bold;
}
.sp-ppl {
  z-index: 3;
  position: absolute;
  font-size: 18px;
  left: 50%;
  top: 70%;
  height: 30px;
  width: 30px;
  background-color: rgb(39, 39, 39);
  border-radius: 50%;
  text-align: center;
  line-height: 32px;
  color: rgb(231, 231, 231);
  transition: transform 0.2s;
}
.sp-card {
  width: 500px;
  height: 300px;
  position: absolute !important;
  top: 15px;
  left: 15px;
  z-index: 4;
  border-radius: 5px;
  overflow: hidden;
}
.sp-currentSituation {
  transform: scale(1.2);
  z-index: 2;
  background: var(--primaryColor);
  border-color: transparent;
  color: white;
  filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 1))
    drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.6));
}

/*DESKTOP SMALL*/
@media (max-width: 1200px) {
  .sp-dot {
    height: 40px;
    width: 40px;
  }
  .sp-ppl {
    font-size: 14px;
    height: 15px;
    width: 15px;
    line-height: 15px;
  }
}
</style>
